
import { actionTypes } from './constants';
import { apiCallStatus } from 'helpers/constants';

const initialState = {
	parameterFileList: {
		data: [],
		loadingStatus: apiCallStatus.LOADING
	},
	parameterFile: {
		data: undefined,
		loadingStatus: apiCallStatus.LOADING
	},
	parameterBackupTypes: {
		data: [],
		loadingStatus: apiCallStatus.LOADING
	},
	triggerParameterBackupStatus: apiCallStatus.SUCCESS,
};

// Reducer

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case actionTypes.GET_PARAMETER_FILE_LIST:
			return {
				...state,
				parameterFileList: { ...state.parameterFileList, ...action }
			};
		case actionTypes.GET_PARAMETER_FILE:
			return {
				...state,
				parameterFile: { ...state.parameterFile, ...action }
			};
		case actionTypes.GET_PARAMETER_BACKUP_TYPES:
			return {
				...state,
				parameterBackupTypes: { ...state.parameterBackupTypes, data: action?.data?.parameterBackupTypes }
			};
		case actionTypes.GET_PARAMETER_BACKUP:
			return {
				...state,
				triggerParameterBackupStatus: action.loadingStatus
			};
		case actionTypes.CLEAR_PARAMETER_FILE_DATA:
			return {
				...initialState
			};
		default:
			return state;
	}
};

export default reducer;

